import { FormikContextType } from 'formik';
import { VerificationModalArgs } from 'views/MForm/MFormFields/MFormSwitch/MFormSwitch';
import { MServerSelectHttpServices } from 'views/MServerSelect/MServerSelect.model';

export enum ValidationDataType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  HoursMintuesObject = 'hoursMinutesObject',
  Object = 'object',
  Url = 'url',
}

export enum FieldRelationOperators {
  Equal = '=',
  NotEqual = '!=',
}

export enum FieldTypes {
  Weekdays = 'weekdays',
  Number = 'number',
  Text = 'text',
  Dropdown = 'dropdown',
  Radio = 'radio',
  HourMintues = 'hours-mintues',
  TextArea = 'Textarea',
  Password = 'password',
  Checkbox = 'checkbox',
  Switch = 'switch',
}

export type IFieldOptions = {
  label: string;
  value: string | number;
};

export type IRequiredType = {
  relationKey: string; // controller
  relationOperator: FieldRelationOperators;
  relationValue: unknown;
};

export type IDynamicFields = {
  controller: string;
  fieldType: FieldTypes;
  // collection or options is used only for dropdowns
  collection?: keyof MServerSelectHttpServices;
  collectionFilters?: Record<string, unknown>;
  options?: IFieldOptions[];
  value?: unknown;
  labelAfter?: string;
  labelBefore?: string;
  labelAbove?: string;
  description?: string;
  nestedFields?: IDynamicFields[];
  info?: string;
  order?: number;
  editable?: boolean; // TODO: this should not be part of IDynamicField as it is only used by integrations page
  confirmSwitchChanges?: boolean | VerificationModalArgs;
};

export type IDynamicValidation = {
  controller: string;
  dataType: ValidationDataType;

  isRequired: boolean | IRequiredType;
  isArray?: boolean;
  defaultValue?: unknown;

  minLength?: number;
  maxLength?: number;

  min?: number;
  max?: number;

  minArraySize?: number;
  maxArraySize?: number;
};

export type IDynamicBuilder<FormType extends Record<string, unknown>> = {
  key: string;
  form: FormikContextType<FormType>;
  isNested?: boolean;
  field: IDynamicFields;
};
